import React from 'react';
import styled from 'styled-components';
import {ReactComponent as ConverseLogo} from 'assets/icons/converse-logo.svg';
import {ReactComponent as NikeLogo} from 'assets/images/swoosh.svg';

const StyledIcon = styled.div`
  grid-area: icon;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: icon;
  width: 36px;
  height: 36px;
  margin: 6px;
  background-color: ${props => props.theme.text}33;
  overflow: hidden;
  object-fit: cover;
  border-radius: 50%;
  &.light {
    background-color: ${props => props.theme.text}33;
    svg {
      fill: ${props => props.theme.text};
    }
  }
  &.dark {
    background-color: ${props => props.theme.black}11;
    svg {
      fill: ${props => props.theme.black};
    }
  }
  .no-brand {
    opacity: 0;
  }
`;

const StyledNikeLogo = styled(NikeLogo)`
  width: 34px;
  height: 34px;
  fill: ${props => props.theme.text};
  position: relative;
  top: -1px;
  left: 1px;
`;

const StyledConverseLogo = styled(ConverseLogo)`
  path {
    fill: ${props => props.theme.text};
    transform: scale(0.4);
    translate: 27% 30%;
  }
`;

interface BrandIconsProps {
  siteBrand: string;
  color?: 'light' | 'dark';
}

export default function BrandIcons({siteBrand, color = 'light'}: BrandIconsProps) {
  const siteString = siteBrand.toLowerCase();

  switch (siteString) {
    case 'nike':
      return (
        <StyledIcon className={color}>
          <StyledNikeLogo />
        </StyledIcon>
      );
    case 'converse':
      return (
        <StyledIcon className={color}>
          <StyledConverseLogo />
        </StyledIcon>
      );
    default:
      return <StyledIcon className={'no-brand'} />;
  }
}
